import React from 'react';
import Link from 'gatsby-link';
import Template from '../../../../components/templates/Anatomy';
import Markdown from '../../../../components/Markdown';
import CodeTabs from '../../../../components/CodeTabs';
import CodeTab from '../../../../components/CodeTab';

export default (props) => {
  return (
    <Template>
      <h1>
        constants/ActionTypes.js
      </h1>
      <p>
        This file is where you should store any custom ActionTypes required for your application, ActionTypes
        that don't fit within the standard framework conventions.
      </p>
      <p>
        Alternatively, if you have disabled blueprints, you would need to specify all of the ActionTypes for
        the application here.
      </p>
      <Markdown text={`
      export default {
        // ADD_MODEL:    'ADD_MODEL',
        // UPDATE_MODEL: 'UPDATE_MODEL',
        // REMOVE_MODEL: 'REMOVE_MODEL',
        // FETCH_MODELS: 'FETCH_MODELS',
        // FETCH_MODEL:  'FETCH_MODEL'
      };
      `}/>
    </Template>
  );
};



// WEBPACK FOOTER //
// ./src/pages/anatomy/src/constants/action-types.js